var _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-380"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-380",
    cx: 257.17,
    cy: 310.54,
    rx: 223.22,
    ry: 119.25,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-380"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-380",
    points: "167.34 376.92 96.17 335.54 216.55 265.97 167.34 376.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-380",
    d: "M64.61,333l29,16.72a4.3,4.3,0,0,0,3.89,0l40-23.34a1.18,1.18,0,0,0,0-2.24l-29-16.73a4.3,4.3,0,0,0-3.89,0l-40,23.34A1.19,1.19,0,0,0,64.61,333Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-380"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.75,330.4c-2-3.22-8.17-6.76-16.27-8.51S35.24,318,37.1,313.27c2-5.07,9.54-5.32,16.91-2.3,8.05,3.3,14,11.46,14.11,16.6Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.75,330.4c-2-3.22-8.17-6.76-16.27-8.51S35.24,318,37.1,313.27c2-5.07,9.54-5.32,16.91-2.3,8.05,3.3,14,11.46,14.11,16.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.38,328.94a.6.6,0,0,1-.54-.35c-6.43-13.3-21.34-15.45-26-14.72a.61.61,0,0,1-.69-.51.6.6,0,0,1,.5-.69c4.94-.76,20.59,1.47,27.32,15.4a.61.61,0,0,1-.28.81A.66.66,0,0,1,68.38,328.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.75,330.4s-3.87-15.33-13.68-23.57c-2.91-2.45-6-5.52-8.19-7.63-4.66-4.54-2.71-9.49,3.74-9.39,9.6.13,16.62,8.21,19.66,18.78S67.75,330.4,67.75,330.4Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28,324.45a.61.61,0,0,1-.61-.55c-1.8-19.5-16.68-29.3-20.73-30.34a.6.6,0,0,1,.3-1.17c4.92,1.26,19.79,11.43,21.64,31.4a.61.61,0,0,1-.55.66Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabinet--inject-380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-380"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "94.59 347.26 67.27 331.48 67.26 272.88 94.59 288.66 94.59 347.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.59 288.66 133.63 266.12 133.63 324.72 94.59 347.26 94.59 288.66",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.63 266.12 94.59 288.66 67.26 272.88 106.31 250.34 133.63 266.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.46,287.94l5.31-3.07c.69-.4,1.25-.22,1.25.41a2.48,2.48,0,0,1-1.25,1.84l-5.31,3.07c-.69.4-1.25.22-1.25-.41A2.48,2.48,0,0,1,111.46,287.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.78 318.38 129.01 300.35 129.73 300.76 129.01 322.05 129.73 322.47 98.5 340.5 97.78 340.08 97.78 318.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.5 318.79 129.73 300.76 129.73 322.47 98.5 340.5 98.5 318.79",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.74,315.4l5.31-3.06c.69-.4,1.25-.22,1.25.4a2.49,2.49,0,0,1-1.25,1.85l-5.31,3.07c-.69.4-1.25.21-1.25-.41A2.51,2.51,0,0,1,110.74,315.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.78 291.38 129.01 273.35 129.73 273.76 129.01 295.05 129.73 295.47 98.5 313.5 97.78 313.08 97.78 291.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.5 291.79 129.73 273.76 129.73 295.47 98.5 313.5 98.5 291.79",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.74,288.4l5.31-3.06c.69-.4,1.25-.22,1.25.4a2.49,2.49,0,0,1-1.25,1.85l-5.31,3.07c-.69.4-1.25.21-1.25-.41A2.51,2.51,0,0,1,110.74,288.4Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-380"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "94.59 286.17 67.27 270.39 67.26 211.78 94.59 227.56 94.59 286.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.59 227.56 133.63 205.02 133.63 263.63 94.59 286.17 94.59 227.56",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.63 205.02 94.59 227.56 67.26 211.78 106.31 189.24 133.63 205.02",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.5 229.81 129.73 211.78 130.45 212.2 130.45 233.9 99.22 251.94 98.5 251.52 98.5 229.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.46,226.84l5.31-3.07c.69-.4,1.25-.21,1.25.41a2.51,2.51,0,0,1-1.25,1.85l-5.31,3.06c-.69.4-1.25.22-1.25-.4A2.49,2.49,0,0,1,111.46,226.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.78 257.28 129.01 239.25 129.01 260.96 129.73 261.37 98.5 279.4 97.78 278.99 97.78 257.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.5 257.7 129.73 239.66 129.73 261.37 98.5 279.4 98.5 257.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.74,254.31l5.31-3.07c.69-.4,1.25-.22,1.25.41a2.48,2.48,0,0,1-1.25,1.84l-5.31,3.07c-.69.4-1.25.22-1.25-.41A2.48,2.48,0,0,1,110.74,254.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.5 229.81 129.73 211.78 129.73 233.49 98.5 251.52 98.5 229.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.35 222.5 128.25 212.64 128.25 231.76 145.35 241.63 145.35 222.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.21 254.61 110.21 227.56 116.91 223.68 118.02 225.31 137.54 214.03 137.54 238.83 110.21 254.61",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "110.21 254.61 110.21 227.56 116.91 223.68 118.02 225.31 137.54 214.03 137.54 238.83 110.21 254.61"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "110.21 254.61 112.16 230.94 139.49 215.16 137.54 238.83 110.21 254.61",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.11 240.54 99.21 231.94 99.21 251.06 114.11 259.66 114.11 240.54",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.11 238.83 145.35 220.8 145.35 242.5 114.11 260.54 114.11 238.83",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.36,235.44l5.31-3.07c.69-.4,1.25-.21,1.25.41a2.51,2.51,0,0,1-1.25,1.85l-5.31,3.06c-.69.4-1.25.22-1.25-.4A2.51,2.51,0,0,1,126.36,235.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.11 238.83 113.07 238.23 113.07 259.94 114.11 260.54 114.11 238.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.07 238.23 144.31 220.2 145.35 220.8 114.11 238.83 113.07 238.23",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-380"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,82.3l-4.06-2.36L163.75,199.54V372.77a3.06,3.06,0,0,0,1.26,2.8h0l4.06,2.36h0a3.06,3.06,0,0,0,3.07-.3L370.64,263a9.58,9.58,0,0,0,4.33-7.5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.81,375.13c0,2.76,1.93,3.88,4.33,2.5L370.64,263a9.58,9.58,0,0,0,4.33-7.5V82.3L167.81,201.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,84V255.52a8.61,8.61,0,0,1-3.83,6.64l-198.5,114.6a3,3,0,0,1-1.44.46c-1.26,0-1.39-1.46-1.39-2.09V202.48L374,84m1-1.73L167.81,201.91V375.13c0,2,1,3.09,2.39,3.09a4,4,0,0,0,1.94-.59L370.64,263a9.58,9.58,0,0,0,4.33-7.5V82.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.81 201.91 167.81 220.66 374.97 101.05 374.97 82.3 167.81 201.91",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.79,134.21v4c0,.82.59,1.16,1.3.75l63.69-36.78v-7L299.09,132A2.9,2.9,0,0,0,297.79,134.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.61,91.25c.72-.42,1.3-.08,1.3.75v4a2.86,2.86,0,0,1-1.3,2.25l-6.83,3.94v-7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11,96.78l-.77-.24a4.06,4.06,0,0,0,.13-1,1.78,1.78,0,0,0-.7-1.62,1.09,1.09,0,0,0-1.11,0,3.89,3.89,0,0,0-1.52,3.17,1.76,1.76,0,0,0,.7,1.62.89.89,0,0,0,.48.13,1.25,1.25,0,0,0,.62-.18,3.16,3.16,0,0,0,1.23-1.65l.77.24H369a.28.28,0,0,0,.27-.19A.29.29,0,0,0,369.11,96.78Zm-2.45,1.46a.51.51,0,0,1-.54.05,1.29,1.29,0,0,1-.41-1.13,3.39,3.39,0,0,1,1.23-2.68.74.74,0,0,1,.35-.11.36.36,0,0,1,.2.06,1.32,1.32,0,0,1,.41,1.13A3.4,3.4,0,0,1,366.66,98.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.68,68.09a3,3,0,0,0-3.1.28L168.08,183a9.55,9.55,0,0,0-4.33,7.5v9.07l4.06,2.37L375,82.3V73.23a3,3,0,0,0-1.25-2.79C373,70,370.39,68.52,369.68,68.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.81,192.84a9.53,9.53,0,0,1,4.33-7.5L370.64,70.73c2.39-1.38,4.33-.26,4.33,2.5V82.3L167.81,201.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.76,70.46a3,3,0,0,0-3.12.27l-198.5,114.6a8.83,8.83,0,0,0-3.06,3.23L165,186.21a8.89,8.89,0,0,1,3.07-3.24L366.58,68.36a3,3,0,0,1,3.1-.27c.71.43,3.31,1.92,4,2.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.6,87a4.49,4.49,0,0,0-2,3.52c0,1.29.91,1.82,2,1.17a4.49,4.49,0,0,0,2-3.52C352.63,86.86,351.72,86.33,350.6,87Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,82.89a4.47,4.47,0,0,0-2,3.51c0,1.3.91,1.82,2,1.18a4.51,4.51,0,0,0,2-3.52C359.74,82.76,358.83,82.24,357.71,82.89Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.81,78.79a4.49,4.49,0,0,0-2,3.52c0,1.3.91,1.82,2,1.17a4.46,4.46,0,0,0,2-3.52C366.85,78.67,365.94,78.14,364.81,78.79Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.14,377.63l36.29-20.95V197.2l-40.62,23.46V375.13C167.81,377.89,169.74,379,172.14,377.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.43,198.93V356.1l-35.79,20.66a3,3,0,0,1-1.44.46c-1.26,0-1.39-1.46-1.39-2.09V221.23l38.62-22.3m1-1.73-40.62,23.46V375.13c0,2,1,3.09,2.39,3.09a4,4,0,0,0,1.94-.59l36.29-20.95V197.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29,222.25,200.73,211c.71-.42,1.29-.08,1.29.75v1.69a2.89,2.89,0,0,1-1.29,2.25l-19.44,11.23c-.72.42-1.3.08-1.3-.75V224.5A2.9,2.9,0,0,1,181.29,222.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.93,226.85v1.69a2.87,2.87,0,0,1-1.3,2.25l-1.46.84c-.72.42-1.3.08-1.3-.75v-1.69a2.87,2.87,0,0,1,1.3-2.25l1.46-.84C175.35,225.68,175.93,226,175.93,226.85Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29,231.6l19.44-11.23c.71-.42,1.29-.08,1.29.74v1.69a2.91,2.91,0,0,1-1.29,2.26l-19.44,11.23c-.72.41-1.3.08-1.3-.75v-1.69A2.88,2.88,0,0,1,181.29,231.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.93,236.19v1.69a2.86,2.86,0,0,1-1.3,2.25l-1.46.85c-.72.41-1.3.08-1.3-.75v-1.69a2.86,2.86,0,0,1,1.3-2.25l1.46-.85C175.35,235,175.93,235.36,175.93,236.19Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29,240.94l19.44-11.23c.71-.41,1.29-.08,1.29.75v1.69a2.87,2.87,0,0,1-1.29,2.25l-19.44,11.23c-.72.42-1.3.08-1.3-.74v-1.7A2.91,2.91,0,0,1,181.29,240.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.93,245.54v1.69a2.86,2.86,0,0,1-1.3,2.25l-1.46.85c-.72.41-1.3.07-1.3-.75v-1.7a2.89,2.89,0,0,1,1.3-2.25l1.46-.84C175.35,244.38,175.93,244.71,175.93,245.54Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29,271.94l19.44-11.24c.71-.41,1.29-.08,1.29.75v1.69a2.87,2.87,0,0,1-1.29,2.25l-19.44,11.24c-.72.41-1.3.08-1.3-.75v-1.69A2.88,2.88,0,0,1,181.29,271.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.93,276.53v1.69a2.86,2.86,0,0,1-1.3,2.25l-1.46.85c-.72.41-1.3.08-1.3-.75v-1.69a2.86,2.86,0,0,1,1.3-2.25l1.46-.85C175.35,275.37,175.93,275.7,175.93,276.53Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29,280.21,200.73,269c.71-.41,1.29-.08,1.29.75v1.69a2.87,2.87,0,0,1-1.29,2.25L181.29,284.9c-.72.42-1.3.08-1.3-.75v-1.69A2.91,2.91,0,0,1,181.29,280.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.93,284.81v1.69a2.86,2.86,0,0,1-1.3,2.25l-1.46.84c-.72.42-1.3.08-1.3-.75v-1.69a2.89,2.89,0,0,1,1.3-2.25l1.46-.84C175.35,283.65,175.93,284,175.93,284.81Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29,288.49l19.44-11.23c.71-.42,1.29-.08,1.29.75v1.69a2.89,2.89,0,0,1-1.29,2.25l-19.44,11.23c-.72.42-1.3.08-1.3-.75v-1.69A2.9,2.9,0,0,1,181.29,288.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.93,293.09v1.69a2.87,2.87,0,0,1-1.3,2.25l-1.46.84c-.72.42-1.3.08-1.3-.75v-1.69a2.87,2.87,0,0,1,1.3-2.25l1.46-.84C175.35,291.92,175.93,292.26,175.93,293.09Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.99 251.15 179.99 254.06 182.52 251.15 179.99 251.15",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.06,250.54c0,.55.38.76.86.48l16.24-9.34a1.91,1.91,0,0,0,.86-1.5c0-.55-.38-.77-.86-.49l-16.24,9.37A1.89,1.89,0,0,0,184.06,250.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.99 255.83 179.99 258.75 182.52 255.83 179.99 255.83",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.06,255.23c0,.54.38.76.86.48l16.24-9.35a1.88,1.88,0,0,0,.86-1.49c0-.55-.38-.77-.86-.49l-16.24,9.37A1.89,1.89,0,0,0,184.06,255.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.99 260.52 179.99 263.44 182.52 260.52 179.99 260.52",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.06,259.92c0,.54.38.76.86.48l16.24-9.35a1.88,1.88,0,0,0,.86-1.49c0-.55-.38-.77-.86-.49l-16.24,9.37A1.89,1.89,0,0,0,184.06,259.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.99 265.21 179.99 268.13 182.52 265.21 179.99 265.21",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.06,264.61c0,.54.38.76.86.48l16.24-9.35a1.88,1.88,0,0,0,.86-1.49c0-.55-.38-.77-.86-.49l-16.24,9.37A1.89,1.89,0,0,0,184.06,264.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.61,202.79v24.44c0,1,.72,1.44,1.61.93l26.87-15.52a3.53,3.53,0,0,0,1.61-2.78V189.77c0-1-.72-1.44-1.61-.93l-15.59,9c-.89.51-1.61.1-1.61-.92v-.64c0-1-.71-1.44-1.6-.93L222.22,200A3.56,3.56,0,0,0,220.61,202.79Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.9,231.84v1.57c0,.76.54,1.07,1.2.69l20.16-11.64a2.65,2.65,0,0,0,1.2-2.08v-1.57c0-.76-.54-1.07-1.2-.69L227.1,229.76A2.65,2.65,0,0,0,225.9,231.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,181.34v24.44c0,1,.72,1.43,1.6.92l26.87-15.51a3.56,3.56,0,0,0,1.61-2.78v-20.1c0-1-.72-1.44-1.61-.93l-15.59,9c-.89.51-1.6.09-1.6-.93v-.64c0-1-.72-1.43-1.61-.92l-8.07,4.66A3.55,3.55,0,0,0,258,181.34Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.26,210.39V212c0,.77.54,1.08,1.2.7L284.62,201a2.68,2.68,0,0,0,1.2-2.09v-1.56c0-.77-.54-1.08-1.2-.69L264.46,208.3A2.68,2.68,0,0,0,263.26,210.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.61,251.89v24.44c0,1,.72,1.44,1.61.93l26.87-15.52A3.55,3.55,0,0,0,250.7,259v-20.1c0-1-.72-1.43-1.61-.92l-15.59,9c-.89.51-1.61.1-1.61-.92v-.64c0-1-.71-1.44-1.6-.93l-8.07,4.66A3.55,3.55,0,0,0,220.61,251.89Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.9,280.94v1.57c0,.76.54,1.07,1.2.69l20.16-11.64a2.67,2.67,0,0,0,1.2-2.08v-1.57c0-.76-.54-1.07-1.2-.69L227.1,278.86A2.65,2.65,0,0,0,225.9,280.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,230.43v24.44c0,1,.72,1.44,1.6.93l26.87-15.52a3.53,3.53,0,0,0,1.61-2.77v-20.1c0-1-.72-1.44-1.61-.93l-15.59,9c-.89.51-1.6.09-1.6-.93v-.64c0-1-.72-1.44-1.61-.92l-8.07,4.66A3.54,3.54,0,0,0,258,230.43Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.26,259.49v1.56c0,.77.54,1.08,1.2.69l20.16-11.63a2.68,2.68,0,0,0,1.2-2.09v-1.56c0-.77-.54-1.08-1.2-.7L264.46,257.4A2.68,2.68,0,0,0,263.26,259.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.78,158.7v24.44c0,1,.72,1.44,1.6.93l26.88-15.52a3.55,3.55,0,0,0,1.6-2.78V145.68c0-1-.72-1.44-1.6-.93l-15.6,9c-.88.52-1.6.1-1.6-.92v-.64c0-1-.72-1.44-1.61-.93l-8.07,4.67A3.54,3.54,0,0,0,295.78,158.7Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.62,188.93v1.57c0,.76.54,1.07,1.21.69L322,179.55a2.64,2.64,0,0,0,1.21-2.08v-1.56c0-.77-.54-1.08-1.21-.7l-20.15,11.64A2.64,2.64,0,0,0,300.62,188.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.7,138.43v24.44c0,1,.72,1.43,1.61.92l26.87-15.51a3.55,3.55,0,0,0,1.6-2.78V125.4c0-1-.71-1.44-1.6-.93l-15.59,9c-.89.51-1.61.09-1.61-.93v-.64c0-1-.71-1.43-1.6-.92l-8.07,4.66A3.53,3.53,0,0,0,332.7,138.43Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,167.48V169c0,.77.53,1.08,1.2.7l20.16-11.64a2.68,2.68,0,0,0,1.2-2.08v-1.57c0-.77-.54-1.08-1.2-.69l-20.16,11.63A2.66,2.66,0,0,0,338,167.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.62,238v1.57c0,.76.54,1.07,1.21.69L322,228.63a2.64,2.64,0,0,0,1.21-2.08V225c0-.76-.54-1.07-1.21-.69l-20.15,11.64A2.64,2.64,0,0,0,300.62,238Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.13,203.66,322,191.59c.95-.55,1.73-.1,1.73,1v24.14a3.83,3.83,0,0,1-1.73,3L301.13,231.8c-1,.55-1.73.11-1.73-1V206.66A3.84,3.84,0,0,1,301.13,203.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.35,232.54a1.4,1.4,0,0,1-.7-.18,1.7,1.7,0,0,1-.75-1.56V206.66a4.32,4.32,0,0,1,2-3.43l20.91-12.07a1.68,1.68,0,0,1,1.72-.12,1.71,1.71,0,0,1,.76,1.55v24.14a4.32,4.32,0,0,1-2,3.43l-20.91,12.08A2.09,2.09,0,0,1,300.35,232.54Zm22.46-40.68a1,1,0,0,0-.52.17L301.38,204.1a3.3,3.3,0,0,0-1.48,2.56V230.8c0,.35.09.6.25.69a.8.8,0,0,0,.73-.12l20.91-12.07a3.35,3.35,0,0,0,1.48-2.57V192.59a.8.8,0,0,0-.26-.69A.42.42,0,0,0,322.81,191.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.5,194.85l-4.66,2.69a3.83,3.83,0,0,0-1.74,3v5.38c0,1.11.78,1.56,1.74,1l4.66-2.69a3.83,3.83,0,0,0,1.73-3v-5.38C326.23,194.75,325.45,194.3,324.5,194.85Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,206.27l10.48-6c.47-.27.86-.05.86.51v.33a1.94,1.94,0,0,1-.86,1.5l-10.48,6c-.48.28-.87.06-.86-.5v-.34A1.91,1.91,0,0,1,302.72,206.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,211l10.48-6c.47-.28.86-.05.86.5v.33a1.91,1.91,0,0,1-.86,1.5l-10.48,6c-.48.28-.87,0-.86-.5v-.35A1.91,1.91,0,0,1,302.72,211Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,215.64l10.48-6c.47-.27.86-.05.86.5v.34a1.94,1.94,0,0,1-.86,1.5l-10.48,6c-.48.28-.87.06-.86-.5v-.34A1.9,1.9,0,0,1,302.72,215.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,220.32l17.4-10c.48-.27.87,0,.87.5v.34a1.92,1.92,0,0,1-.87,1.5l-17.4,10c-.48.27-.87.05-.86-.5v-.35A1.91,1.91,0,0,1,302.72,220.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,225l17.4-10c.48-.28.87,0,.87.5v.33a1.91,1.91,0,0,1-.87,1.5l-17.4,10c-.48.28-.87.05-.86-.5v-.34A1.88,1.88,0,0,1,302.72,225Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.18,216.91v1.56c0,.77.54,1.08,1.2.7l20.16-11.64a2.66,2.66,0,0,0,1.2-2.09v-1.56c0-.77-.53-1.08-1.2-.7l-20.16,11.64A2.68,2.68,0,0,0,337.18,216.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.69,182.56l20.9-12.07c1-.56,1.74-.11,1.74,1v24.14a3.85,3.85,0,0,1-1.74,3l-20.9,12.07c-1,.55-1.74.1-1.74-1V185.56A3.82,3.82,0,0,1,337.69,182.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.91,211.43a1.4,1.4,0,0,1-.7-.18,1.71,1.71,0,0,1-.76-1.55V185.56a4.32,4.32,0,0,1,2-3.44l20.9-12.07a1.55,1.55,0,0,1,2.49,1.44v24.14a4.31,4.31,0,0,1-2,3.43l-20.9,12.07A2.09,2.09,0,0,1,336.91,211.43Zm1-28.44a3.32,3.32,0,0,0-1.49,2.57V209.7a.8.8,0,0,0,.26.69.78.78,0,0,0,.73-.13l20.9-12.07a3.31,3.31,0,0,0,1.49-2.56V171.49a.58.58,0,0,0-1-.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.05,173.75l-4.66,2.69a3.83,3.83,0,0,0-1.73,3v5.38c0,1.1.78,1.55,1.73,1l4.66-2.69a3.85,3.85,0,0,0,1.74-3v-5.38C362.79,173.64,362,173.19,361.05,173.75Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28,185.16l10.47-6c.48-.28.87,0,.87.5V180a1.89,1.89,0,0,1-.87,1.5l-10.47,6c-.48.28-.87.05-.87-.5v-.35A1.92,1.92,0,0,1,339.28,185.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28,189.85l10.47-6c.48-.27.87,0,.87.5v.34a1.92,1.92,0,0,1-.87,1.5l-10.47,6c-.48.28-.87.06-.87-.5v-.34A1.91,1.91,0,0,1,339.28,189.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28,194.53l10.47-6c.48-.28.87,0,.87.5v.33a1.91,1.91,0,0,1-.87,1.5l-10.47,6c-.48.27-.87.05-.87-.5V196A1.92,1.92,0,0,1,339.28,194.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28,199.22l17.4-10c.48-.28.87-.05.87.5V190a1.92,1.92,0,0,1-.87,1.5l-17.4,10c-.48.28-.87.05-.87-.5v-.34A1.89,1.89,0,0,1,339.28,199.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28,203.9l17.4-10c.48-.27.87-.05.87.5v.34a1.92,1.92,0,0,1-.87,1.5l-17.4,10c-.48.27-.87.05-.87-.5v-.35A1.92,1.92,0,0,1,339.28,203.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.62,287.83v1.57c0,.76.54,1.07,1.21.69L322,278.45a2.64,2.64,0,0,0,1.21-2.08V274.8c0-.76-.54-1.07-1.21-.69l-20.15,11.64A2.64,2.64,0,0,0,300.62,287.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.13,253.48,322,241.41c.95-.55,1.73-.1,1.73,1v24.14a3.85,3.85,0,0,1-1.73,3l-20.91,12.07c-1,.55-1.73.11-1.73-1V256.48A3.82,3.82,0,0,1,301.13,253.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.35,282.36a1.4,1.4,0,0,1-.7-.18,1.72,1.72,0,0,1-.75-1.56V256.48a4.32,4.32,0,0,1,2-3.43L321.79,241a1.55,1.55,0,0,1,2.48,1.43v24.14a4.32,4.32,0,0,1-2,3.43l-20.91,12.07A2.11,2.11,0,0,1,300.35,282.36Zm22.46-40.69a1.09,1.09,0,0,0-.52.17l-20.91,12.08a3.29,3.29,0,0,0-1.48,2.56v24.14a.58.58,0,0,0,1,.57l20.91-12.07a3.35,3.35,0,0,0,1.48-2.57V242.41a.8.8,0,0,0-.26-.69A.42.42,0,0,0,322.81,241.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.5,244.67l-4.66,2.69a3.83,3.83,0,0,0-1.74,3v5.38c0,1.11.78,1.55,1.74,1l4.66-2.69a3.83,3.83,0,0,0,1.73-3v-5.38C326.23,244.57,325.45,244.12,324.5,244.67Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,256.09l10.48-6c.47-.27.86-.05.86.5v.34a1.94,1.94,0,0,1-.86,1.5l-10.48,6c-.48.28-.87.06-.86-.5v-.34A1.9,1.9,0,0,1,302.72,256.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,260.77l10.48-6c.47-.28.86-.05.86.5v.33a1.92,1.92,0,0,1-.86,1.5l-10.48,6c-.48.27-.87.05-.86-.5v-.35A1.91,1.91,0,0,1,302.72,260.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,265.46l10.48-6c.47-.27.86-.05.86.5v.34a1.94,1.94,0,0,1-.86,1.5l-10.48,6c-.48.28-.87.05-.86-.5V267A1.88,1.88,0,0,1,302.72,265.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,270.14l17.4-10c.48-.27.87-.05.87.5V261a1.92,1.92,0,0,1-.87,1.5l-17.4,10c-.48.27-.87.05-.86-.5v-.35A1.91,1.91,0,0,1,302.72,270.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,274.83l17.4-10c.48-.28.87-.06.87.5v.33a1.92,1.92,0,0,1-.87,1.5l-17.4,10c-.48.28-.87.05-.86-.5v-.34A1.88,1.88,0,0,1,302.72,274.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.18,266.72v1.57c0,.77.54,1.08,1.2.69l20.16-11.63a2.66,2.66,0,0,0,1.2-2.09V253.7c0-.77-.53-1.08-1.2-.7l-20.16,11.64A2.68,2.68,0,0,0,337.18,266.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.69,232.38l20.9-12.07c1-.56,1.74-.11,1.74,1v24.13a3.82,3.82,0,0,1-1.74,3l-20.9,12.08c-1,.55-1.74.1-1.74-1V235.38A3.82,3.82,0,0,1,337.69,232.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.91,261.25a1.4,1.4,0,0,1-.7-.18,1.71,1.71,0,0,1-.76-1.55V235.38a4.31,4.31,0,0,1,2-3.44l20.9-12.07a1.55,1.55,0,0,1,2.49,1.44v24.13a4.31,4.31,0,0,1-2,3.44L337.94,261A2.09,2.09,0,0,1,336.91,261.25Zm1-28.44a3.32,3.32,0,0,0-1.49,2.57v24.14a.76.76,0,0,0,.26.68.77.77,0,0,0,.73-.12L358.34,248a3.32,3.32,0,0,0,1.49-2.57V221.31a.58.58,0,0,0-1-.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.05,223.57l-4.66,2.69a3.83,3.83,0,0,0-1.73,3v5.38c0,1.1.78,1.55,1.73,1l4.66-2.69a3.85,3.85,0,0,0,1.74-3v-5.38C362.79,223.46,362,223,361.05,223.57Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28,235l10.47-6c.48-.28.87-.05.87.5v.33a1.91,1.91,0,0,1-.87,1.5l-10.47,6c-.48.27-.87,0-.87-.5v-.35A1.92,1.92,0,0,1,339.28,235Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28,239.67l10.47-6c.48-.27.87,0,.87.5v.34a1.92,1.92,0,0,1-.87,1.5l-10.47,6c-.48.28-.87.05-.87-.5v-.34A1.89,1.89,0,0,1,339.28,239.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28,244.35l10.47-6c.48-.28.87-.06.87.5v.33a1.92,1.92,0,0,1-.87,1.5l-10.47,6c-.48.27-.87.05-.87-.5v-.35A1.92,1.92,0,0,1,339.28,244.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28,249l17.4-10c.48-.28.87-.06.87.5v.33a1.92,1.92,0,0,1-.87,1.5l-17.4,10c-.48.28-.87.05-.87-.5v-.34A1.89,1.89,0,0,1,339.28,249Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28,253.72l17.4-10c.48-.28.87-.05.87.5v.33a1.89,1.89,0,0,1-.87,1.5l-17.4,10c-.48.27-.87.05-.87-.5v-.35A1.92,1.92,0,0,1,339.28,253.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.9,331v1.56c0,.77.54,1.08,1.21.7l20.15-11.64a2.65,2.65,0,0,0,1.21-2.08V318c0-.77-.54-1.08-1.21-.69l-20.15,11.63A2.67,2.67,0,0,0,225.9,331Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.41,296.65l20.91-12.07c1-.55,1.73-.11,1.73,1v24.14a3.86,3.86,0,0,1-1.73,3l-20.91,12.07c-1,.55-1.73.1-1.73-1V299.65A3.81,3.81,0,0,1,226.41,296.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.63,325.52a1.4,1.4,0,0,1-.7-.18,1.7,1.7,0,0,1-.75-1.55V299.65a4.32,4.32,0,0,1,2-3.43l20.91-12.07a1.54,1.54,0,0,1,2.48,1.43v24.14a4.32,4.32,0,0,1-2,3.43l-20.91,12.07A2.09,2.09,0,0,1,225.63,325.52Zm.78-28.87.25.43a3.32,3.32,0,0,0-1.48,2.57v24.14a.58.58,0,0,0,1,.57l20.91-12.08a3.33,3.33,0,0,0,1.48-2.56V285.58a.58.58,0,0,0-1-.57l-20.91,12.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.78,287.84l-4.66,2.69a3.82,3.82,0,0,0-1.74,3v5.38c0,1.1.78,1.55,1.74,1l4.66-2.69a3.85,3.85,0,0,0,1.73-3v-5.38C251.51,287.73,250.73,287.29,249.78,287.84Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,299.26l10.48-6c.47-.28.86-.05.86.5v.33a1.91,1.91,0,0,1-.86,1.5l-10.48,6c-.48.28-.86,0-.86-.5v-.34A1.88,1.88,0,0,1,228,299.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,303.94l10.48-6c.47-.27.86-.05.86.51v.33a1.94,1.94,0,0,1-.86,1.5l-10.48,6c-.48.27-.86,0-.86-.5v-.35A1.91,1.91,0,0,1,228,303.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,308.63l10.48-6c.47-.28.86-.05.86.5v.33a1.91,1.91,0,0,1-.86,1.5L228,311c-.48.28-.86,0-.86-.5v-.35A1.88,1.88,0,0,1,228,308.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,313.31l17.4-10c.48-.28.87,0,.87.5v.33a1.89,1.89,0,0,1-.87,1.5l-17.4,10c-.48.28-.86.06-.86-.5v-.34A1.91,1.91,0,0,1,228,313.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,318l17.4-10c.48-.27.87,0,.87.5v.34a1.92,1.92,0,0,1-.87,1.5l-17.4,10c-.48.27-.86.05-.86-.5v-.35A1.91,1.91,0,0,1,228,318Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.46,309.89v1.57c0,.76.54,1.08,1.2.69l20.16-11.64a2.62,2.62,0,0,0,1.2-2.08v-1.56c0-.77-.53-1.08-1.2-.7l-20.16,11.64A2.67,2.67,0,0,0,262.46,309.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,275.54l20.9-12.07c1-.55,1.74-.1,1.74,1v24.14a3.82,3.82,0,0,1-1.74,3L263,303.68c-1,.56-1.74.11-1.74-1V278.54A3.85,3.85,0,0,1,263,275.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.19,304.42a1.4,1.4,0,0,1-.7-.18,1.73,1.73,0,0,1-.76-1.56V278.54a4.33,4.33,0,0,1,2-3.43L283.62,263a1.55,1.55,0,0,1,2.49,1.43v24.14a4.29,4.29,0,0,1-2,3.43l-20.9,12.08A2.09,2.09,0,0,1,262.19,304.42Zm22.46-40.68a1,1,0,0,0-.53.17L263.22,276a3.31,3.31,0,0,0-1.49,2.56v24.14a.77.77,0,0,0,.26.69.8.8,0,0,0,.73-.12l20.9-12.07a3.33,3.33,0,0,0,1.49-2.57V264.47a.8.8,0,0,0-.26-.69A.45.45,0,0,0,284.65,263.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.33,266.73l-4.66,2.69a3.86,3.86,0,0,0-1.73,3v5.38c0,1.11.78,1.56,1.73,1l4.66-2.69a3.82,3.82,0,0,0,1.74-3v-5.38C288.07,266.63,287.29,266.18,286.33,266.73Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.56,278.15l10.47-6c.48-.27.87-.05.87.51V273a1.92,1.92,0,0,1-.87,1.5l-10.47,6c-.48.27-.87.05-.87-.51v-.34A1.92,1.92,0,0,1,264.56,278.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.56,282.84l10.47-6c.48-.28.87-.05.87.5v.33a1.89,1.89,0,0,1-.87,1.5l-10.47,6c-.48.28-.87.05-.87-.5v-.35A1.89,1.89,0,0,1,264.56,282.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.56,287.52l10.47-6c.48-.27.87-.05.87.5v.34a1.92,1.92,0,0,1-.87,1.5l-10.47,6c-.48.28-.87.06-.87-.5V289A1.92,1.92,0,0,1,264.56,287.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.56,292.2l17.4-10c.48-.27.87-.05.87.5V283a1.92,1.92,0,0,1-.87,1.5l-17.4,10c-.48.27-.87.05-.87-.5v-.35A1.92,1.92,0,0,1,264.56,292.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.56,296.89l17.4-10c.48-.28.87-.05.87.5v.33a1.91,1.91,0,0,1-.87,1.5l-17.4,10c-.48.28-.87,0-.87-.5v-.34A1.89,1.89,0,0,1,264.56,296.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.81 201.91 163.75 199.54 163.75 218.31 167.81 220.66 167.81 201.91",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.81 201.91 163.75 199.54 163.75 218.31 167.81 220.66 167.81 201.91",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-380"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.73,279.47h0a2.9,2.9,0,0,0-2.88.28,9,9,0,0,0-4.08,7,2.88,2.88,0,0,0,1.18,2.64h0l50.62,32h0c1,.7,2.51.66,4.16-.29a12.55,12.55,0,0,0,5.71-9.83c0-1.9-.7-3.21-1.82-3.76h0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.77,286.79c0,2.59,1.81,3.65,4.06,2.36a9,9,0,0,0,4.08-7c0-2.59-1.81-3.65-4.06-2.36A9,9,0,0,0,400.77,286.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.57,272.74A5.43,5.43,0,0,0,387.1,277a1.74,1.74,0,0,0,.71,1.59h0l15.28,8.87h0a1.71,1.71,0,0,0,1.73-.17A5.4,5.4,0,0,0,407.3,283a1.72,1.72,0,0,0-.71-1.6l-15.28-8.87h0A1.73,1.73,0,0,0,389.57,272.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.74,287.49l52.08,32a10,10,0,0,1-2.08,1.65c-1.65.95-3.13,1-4.17.29h0l-50.61-32a2.85,2.85,0,0,0,2.87-.28A7.41,7.41,0,0,0,406.74,287.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.48,241.93c0-.43,0-.84-.06-1.26s-.05-.83-.1-1.24-.05-.54-.08-.81c-.07-.72-.18-1.42-.29-2.09-.06-.3-.11-.62-.17-.92s-.12-.57-.18-.86c-.18-.77-.36-1.53-.58-2.25-.12-.34-.22-.69-.34-1a1.42,1.42,0,0,1-.05-.16c-.13-.34-.24-.66-.37-1a11.68,11.68,0,0,0-.46-1.08,7.76,7.76,0,0,0-.37-.77,3,3,0,0,0-.27-.54c-.1-.22-.22-.44-.34-.65l-.09-.15c-.1-.19-.22-.37-.33-.56s-.16-.24-.23-.36a20,20,0,0,0-1.8-2.4c-.12-.12-.23-.25-.34-.37s-.19-.2-.28-.3l-.37-.36a11.08,11.08,0,0,0-1.09-1,5.79,5.79,0,0,0-.55-.43c-.19-.15-.38-.29-.58-.42a9.29,9.29,0,0,0-.93-.61l-.25-.16-.05,0h0l-11-6.39h0l-.08-.05a18.65,18.65,0,0,0-9.32-2.36c-4.86,0-10.34,1.6-16.15,4.95-20,11.52-36.14,39.54-36.14,62.6,0,11.49,4,19.57,10.52,23.36l.06,0h0l11,6.38h0l.06,0h0l.18.1c.29.16.57.31.86.45s.72.33,1.09.48.66.26,1,.36a3.68,3.68,0,0,0,.54.16,3.08,3.08,0,0,0,.57.17l.59.15a3.29,3.29,0,0,0,.43.09l.78.14.18,0,.94.12c5.39.57,11.65-.95,18.35-4.81,20-11.53,36.14-39.56,36.14-62.6C415.51,243,415.5,242.48,415.48,241.93Zm-24.21-16.3a32.35,32.35,0,0,1,1.14,8.8c0,20.33-14.88,46.09-32.48,56.25a31.41,31.41,0,0,1-8.24,3.43,32.37,32.37,0,0,1-1.14-8.81c0-20.33,14.87-46.09,32.48-56.25A31.22,31.22,0,0,1,391.27,225.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.3,308.42l-10.6-6.14c-6.5-3.8-10.52-11.89-10.52-23.36,0-10.28,3.22-21.54,8.55-31.89l11,6.39c-5.34,10.34-8.56,21.61-8.56,31.89C343.21,296.55,347,304.52,353.3,308.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.48,241.93c0-.43,0-.84-.06-1.26s-.05-.83-.1-1.24-.05-.54-.08-.81c-.07-.72-.18-1.42-.29-2.09-.06-.3-.11-.62-.17-.92s-.12-.57-.18-.86c-.18-.77-.36-1.53-.58-2.25-.12-.34-.22-.69-.34-1a1.42,1.42,0,0,1-.05-.16c-.13-.34-.24-.66-.37-1a11.68,11.68,0,0,0-.46-1.08,7.76,7.76,0,0,0-.37-.77,3,3,0,0,0-.27-.54c-.1-.22-.22-.44-.34-.65l-.09-.15c-.1-.19-.22-.37-.33-.56s-.16-.24-.23-.36a20,20,0,0,0-1.8-2.4c-.12-.12-.23-.25-.34-.37s-.19-.2-.28-.3l-.37-.36a11.08,11.08,0,0,0-1.09-1,5.79,5.79,0,0,0-.55-.43c-.19-.15-.38-.29-.58-.42a9.29,9.29,0,0,0-.93-.61c-6.56-4-16-3.9-25.86,2.33-19.81,12.48-36.05,40.15-36.15,62.6-.05,11.68,4.14,19.83,10.83,23.54.29.16.57.31.86.45s.72.33,1.09.48.66.26,1,.36a3.68,3.68,0,0,0,.54.16,3.08,3.08,0,0,0,.57.17l.59.15a3.29,3.29,0,0,0,.43.09l.78.14.18,0,.94.12c5.39.57,11.65-.95,18.35-4.81,20-11.53,36.14-39.56,36.14-62.6C415.51,243,415.5,242.48,415.48,241.93Zm-39.78,57.9c-4.48,2.59-8.79,3.95-12.48,3.95-6.92,0-10.1-4.72-11.53-9.67a32.37,32.37,0,0,1-1.14-8.81c0-20.33,14.87-46.09,32.48-56.25a31.22,31.22,0,0,1,8.24-3.42,18.49,18.49,0,0,1,4.24-.53c11.44,0,12.66,12.92,12.66,18.48C408.17,263.91,393.31,289.67,375.7,299.83Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.17,243.58c0,20.32-14.86,46.09-32.47,56.25-4.48,2.59-8.79,3.95-12.47,3.95a10.61,10.61,0,0,1-8.51-3.73h0c-.18-.21-.35-.43-.52-.65s-.33-.45-.47-.69a5.33,5.33,0,0,1-.31-.51c-.07-.11-.14-.22-.2-.33s-.14-.28-.22-.42-.13-.26-.19-.39-.13-.26-.19-.4l-.3-.72c-.12-.3-.23-.6-.33-.91s-.21-.61-.29-.92a31.41,31.41,0,0,0,8.24-3.43c17.6-10.16,32.48-35.92,32.48-56.25a32.35,32.35,0,0,0-1.14-8.8,18.49,18.49,0,0,1,4.24-.53,14.84,14.84,0,0,1,1.67.1l.52.08h0C407.1,226.84,408.17,238.4,408.17,243.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.85,240c0,20.33-14.86,46.09-32.47,56.25-4.48,2.59-8.79,4-12.48,4a12.78,12.78,0,0,1-2.19-.18c-.18-.21-.35-.43-.52-.65s-.33-.45-.47-.69a5.33,5.33,0,0,1-.31-.51c-.07-.11-.14-.22-.2-.33s-.14-.28-.22-.42-.13-.26-.19-.39-.13-.26-.19-.4l-.3-.72c-.12-.3-.23-.6-.33-.91s-.21-.61-.29-.92a31.41,31.41,0,0,0,8.24-3.43c17.6-10.16,32.48-35.92,32.48-56.25a32.35,32.35,0,0,0-1.14-8.8,18.49,18.49,0,0,1,4.24-.53,14.84,14.84,0,0,1,1.67.1l.52.08C401.32,229.54,401.85,236.37,401.85,240Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.3548d8aebc14c095e2460e33095a500d.svg";
export { ForwardRef as ReactComponent };